export default async function fetchOverride(url: string, options: RequestInit): Promise<Response> {
  // The SDK serialises provider codes as `lenders=…` but the backend expects `vendors=…`
  let resolvedUrl = url;
  if (url.includes('/orders/search') && url.includes('lenders=')) {
    resolvedUrl = url.replace(/([?&])lenders=/g, '$1vendors=');
  }

  const response = await fetch(resolvedUrl, options);

  if (!response.ok) {
    // Try to extract a structured message from the response body.
    // Fall back gracefully when the body is not JSON or has no `message` field.
    let backendMessage: string | undefined;
    try {
      const contentType = response.headers.get('content-type') ?? '';
      if (contentType.includes('application/json')) {
        const errorBody = await response.json();
        backendMessage = typeof errorBody?.message === 'string' ? errorBody.message : undefined;
      }
    } catch {
      // body is not valid JSON – ignore and fall through to the generic message
    }

    throw new Error(backendMessage ?? `Request failed with status ${response.status}`);
  }

  return response;
}
